export default __webpack_public_path__ + "static/gurnik-be03df5b2c2421a54d435e5600ee0f2c.png";